import { render, staticRenderFns } from "./workerFileDetail.vue?vue&type=template&id=79b37456&"
import script from "./workerFileDetail.vue?vue&type=script&lang=js&"
export * from "./workerFileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports